const isProd = true;
export default isProd;
